import { useEffect, useState } from "react";
import { useSettings } from "../../context/SettingsContext";
import { useTheme } from "../../context/ThemeContext";
import { selectStylesDark, selectStylesLigth } from "../../utils/helpers/structs/selectStyles";
import { useTranslation } from "react-i18next";
import Select from "react-select";


const LocalesList = ({onChange, value, width='fit-content', emptyTitle='Empty', idDisabled = false}) => {
    
    const { t } = useTranslation();
    const { settings } = useSettings();
    const { darkTheme } = useTheme();       
    const [ localeList, setLocalesList ] = useState(null);
    const [ selectTheme, setSelectTheme ] = useState(darkTheme?selectStylesDark:selectStylesLigth)


    useEffect(()=>{
        // Формуємо список локалізацій для Select
        const locales = (settings?.site?.locales||'').split(',');
        setLocalesList([
            {value:'', label:emptyTitle},
            ...([...new Set(locales)]).filter(l=> (l!='') ).map(l=>({label:l, value:l}))
        ]);
        
    }, [settings?.site?.locales])

    // Хук зміни теми
    useEffect(()=>{
        setSelectTheme(darkTheme?selectStylesDark:selectStylesLigth)
    },[darkTheme])

    return (
        <Select     
            isDisabled={idDisabled}             
            styles={{
                ...selectTheme, // Зберігаємо існуючі стилі
                control: (base, state) => ({
                ...base,
                ...(selectTheme.control ? selectTheme.control(base, state) : {}), 
                width:width,
                padding:'0px',
                }),
            }} 
            value={localeList?.find(locale=>locale.value === value)}
            onChange={(opt)=>onChange(opt)}
            menuPlacement="top"
            options={localeList}/> 
    )
}

export default LocalesList;